import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const TableContainer = styled(FlexContainer)({
  height: "100%",
  width: "100%",
  overflow: "auto",
  "& table": {
    width: "100%",
  },
  "& thead th": {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: SCIENT_COLORS.darkGray1,
    borderBottom: "1px solid #444",
  },
  "& td.center-icon": {
    // Add this for centered icon
    textAlign: "center",
  },
  "& th:nth-child(1), & td:nth-child(1)": {
    width: "40%", // Name
  },
  "& th:nth-child(2), & td:nth-child(2)": {
    width: "20%", // Code
  },
  "& th:nth-child(3), & td:nth-child(3)": {
    width: "3%", // Source
  },
  "& th:nth-child(4), & td:nth-child(4)": {
    width: "10%", // Future release date
  },
  "& th:nth-child(5), & td:nth-child(5)": {
    width: "3%", // Edit
  },
})
